import HttpStatus from 'http-status-codes';

import { AuthFailureReason } from '../../common/auth/authFailureReasons';
import { RESPONSE_ERROR } from '../../common/error/errorConstants';

type CurrentUserAuthError = {
    response?: {
        status?: number;
        data?: {
            error?: {
                code?: string;
                errorLocaleKey?: string;
                details?: {
                    authFailureReason?: AuthFailureReason;
                };
            };
        };
    };
};

/**
 * Determines whether a current-user request failed because no valid auth state was available.
 */
export const isUnauthenticatedCurrentUserError = (error: CurrentUserAuthError): boolean => {
    const responseStatus = error.response?.status;
    const responseError = error.response?.data?.error;

    if (responseStatus === HttpStatus.UNAUTHORIZED) return true;

    return (
        responseStatus === HttpStatus.BAD_REQUEST &&
        responseError?.code === RESPONSE_ERROR.BAD_REQUEST &&
        !!responseError?.errorLocaleKey?.startsWith('auth.')
    );
};

/**
 * A missing Better Auth cookie session is an expected result of probing /users/me without a legacy token.
 * Any invalid credential that was sent should still be reported.
 */
export const shouldReportCurrentUserAuthFailure = ({ error }: { error: CurrentUserAuthError }): boolean =>
    error.response?.data?.error?.details?.authFailureReason !== AuthFailureReason.missingAuthentication;
